export const MIXPANEL_TOKEN: string =
  process.env.REACT_APP_MIXPANEL_TOKEN || '08cf43f64151daad41450fa19c7ecb95';
export const API_URL =
  process.env.REACT_APP_API_URL || 'https://w0y7qiu9a0.execute-api.us-east-1.amazonaws.com';

export const API_PROXY_URL =
  process.env.REACT_APP_API_PROXY_URL || 'https://40vh0tlj99.execute-api.us-east-1.amazonaws.com';
